import { render } from "./_video.vue?vue&type=template&id=8b32a23a&scoped=true"
import script from "./_video.vue?vue&type=script&lang=js"
export * from "./_video.vue?vue&type=script&lang=js"

import "./_video.vue?vue&type=style&index=0&id=8b32a23a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b32a23a"]])

export default __exports__